import { useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';

export default function useCopyToClipboard() {
  const { popSuccess } = useContext(PopNotificationsContext);

  const { t } = useTranslation();

  return useCallback(
    (e: React.MouseEvent, text: string) => {
      if (e) {
        e.stopPropagation();
      }

      navigator.clipboard.writeText(text);
      popSuccess(t('copiedToClipboard'));
    },
    [popSuccess, t],
  );
}
